import React from 'react';
import {Form} from 'react-bootstrap';
import HTMLRichTextEditor from '@/components/rich_text_editor/HTMLRichTextEditor';

export interface RichTextEditorFieldProps {
  id?: string;
  name: string;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  error?: string;
  touched?: boolean;
  minHeight?: string;
  maxHeight?: string;
  customHeight?: { minHeight?: string; maxHeight?: string };
  'data-cy'?: string;
}

const RichTextEditorField: React.FC<RichTextEditorFieldProps> = ({
    id,
    name,
    label,
    value,
    onChange,
    placeholder,
    isDisabled = false,
    isRequired = false,
    error,
    touched,
    minHeight = '250px',
    maxHeight,
    customHeight,
    'data-cy': dataCy,
}) => {
    const heightConfig = customHeight || {
        minHeight,
        ...(maxHeight && {maxHeight}),
    };

    return (
        <Form.Group className="mb-3" controlId={id || name}>
            {
                label && (
                    <Form.Label>
                        {label}
                        {isRequired && <span className="text-danger"> *</span>}
                    </Form.Label>
                )
            }

            <HTMLRichTextEditor
                HTMLValue={value}
                onChange={onChange}
                customHeight={heightConfig}
            />

            {
                touched && error && (
                    <div className="invalid-feedback d-block">
                        {error}
                    </div>
                )
            }
        </Form.Group >
    );
};

export default RichTextEditorField;
